import React from "react";
import { cn } from "../../lib/utils";

interface StepHeaderProps {
  title: string;
  description: string;
  style?: React.CSSProperties;
  className?: string;
}

const StepHeader: React.FC<StepHeaderProps> = ({ title, description, style, className }) => (
  <div className={cn("space-y-1", className)} style={style}>
    <h3 className="text-xl font-gc-med text-foreground m-0">{title}</h3>
    <p className="text-sm text-muted-foreground m-0">{description}</p>
  </div>
);

export default StepHeader;
